// S3 batch2 — Pure helpers for obligation info-source seeding/merging.
// Extracted to a non-component file so fast-refresh and vitest can import
// them without triggering the Fluent popup jsdom hang.

import type { StateTaxObligationSummary } from '../../types';

/**
 * Seed the multi-select from app-owned sources, falling back to the
 * Dataverse single-select label when no app-owned doc exists yet.
 *
 * Priority:
 *   1. informationSources (app-owned, multi-valued) when non-empty
 *   2. [informationSourceLabel] (Dataverse fallback) when label is set
 *   3. [] (nothing selected)
 */
export function seedInfoSources(o: StateTaxObligationSummary): string[] {
  if (o.informationSources && o.informationSources.length > 0) return [...o.informationSources];
  if (o.informationSourceLabel) return [o.informationSourceLabel];
  return [];
}
